import { ItemList } from 'models/InputLayoutItem';

const createItemComuna = (comunasList: string[]): ItemList[] => {
	let comunaItemList: ItemList[] = [];
	comunasList.forEach((item) => comunaItemList.push({ value: item, label: item }));
	return comunaItemList;
};

export const comunas = new Map<string, ItemList[]>([
	['XV', createItemComuna(['Arica', 'Camarones', 'Putre', 'General Lagos'])],
	[
		'I',
		createItemComuna([
			'Iquique',
			'Alto Hospicio',
			'Pozo Almonte',
			'Camiña',
			'Colchane',
			'Huara',
			'Pica',
		]),
	],
	[
		'II',
		createItemComuna([
			'Antofagasta',
			'Mejillones',
			'Sierra Gorda',
			'Taltal',
			'Calama',
			'Ollagüe',
			'San Pedro de Atacama',
			'Tocopilla',
			'María Elena',
		]),
	],
	[
		'III',
		createItemComuna([
			'Copiapó',
			'Caldera',
			'Tierra Amarilla',
			'Chañaral',
			'Diego de Almagro',
			'Vallenar',
			'Alto del Carmen',
			'Freirina',
			'Huasco',
		]),
	],
	[
		'IV',
		createItemComuna([
			'La Serena',
			'Coquimbo',
			'Andacollo',
			'La Higuera',
			'Paiguano',
			'Vicuña',
			'Illapel',
			'Canela',
			'Los Vilos',
			'Salamanca',
			'Ovalle',
			'Combarbalá',
			'Monte Patria',
			'Punitaqui',
			'Río Hurtado',
		]),
	],
	[
		'V',
		createItemComuna([
			'Valparaíso',
			'Casablanca',
			'Concón',
			'Juan Fernández',
			'Puchuncaví',
			'Quintero',
			'Viña del Mar',
			'Isla de Pascua',
			'Los Andes',
			'Calle Larga',
			'Rinconada',
			'San Esteban',
			'La Ligua',
			'Cabildo',
			'Papudo',
			'Petorca',
			'Zapallar',
			'Quillota',
			'Calera',
			'Hijuelas',
			'La Cruz',
			'Nogales',
			'San Antonio',
			'Algarrobo',
			'Cartagena',
			'El Quisco',
			'El Tabo',
			'Santo Domingo',
			'San Felipe',
			'Catemu',
			'Llaillay',
			'Panquehue',
			'Putaendo',
			'Santa María',
			'Quilpué',
			'Limache',
			'Olmué',
			'Villa Alemana',
		]),
	],
	[
		'VI',
		createItemComuna([
			'Rancagua',
			'Codegua',
			'Coinco',
			'Coltauco',
			'Doñihue',
			'Graneros',
			'Las Cabras',
			'Machalí',
			'Malloa',
			'Mostazal',
			'Olivar',
			'Peumo',
			'Pichidegua',
			'Quinta de Tilcoco',
			'Rengo',
			'Requínoa',
			'San Vicente',
			'Pichilemu',
			'La Estrella',
			'Litueche',
			'Marchihue',
			'Navidad',
			'Paredones',
			'San Fernando',
			'Chépica',
			'Chimbarongo',
			'Lolol',
			'Nancagua',
			'Palmilla',
			'Peralillo',
			'Placilla',
			'Pumanque',
			'Santa Cruz',
		]),
	],
	[
		'VII',
		createItemComuna([
			'Talca',
			'Constitución',
			'Curepto',
			'Empedrado',
			'Maule',
			'Pelarco',
			'Pencahue',
			'Río Claro',
			'San Clemente',
			'San Rafael',
			'Cauquenes',
			'Chanco',
			'Pelluhue',
			'Curicó',
			'Hualañé',
			'Licantén',
			'Molina',
			'Rauco',
			'Romeral',
			'Sagrada Familia',
			'Teno',
			'Vichuquén',
			'Linares',
			'Colbún',
			'Longaví',
			'Parral',
			'Retiro',
			'San Javier',
			'Villa Alegre',
			'Yerbas Buenas',
		]),
	],
	[
		'VIII',
		createItemComuna([
			'Concepción',
			'Coronel',
			'Chiguayante',
			'Florida',
			'Hualqui',
			'Lota',
			'Penco',
			'San Pedro de la Paz',
			'Santa Juana',
			'Talcahuano',
			'Tomé',
			'Hualpén',
			'Lebu',
			'Arauco',
			'Cañete',
			'Contulmo',
			'Curanilahue',
			'Los Álamos',
			'Tirúa',
			'Los Ángeles',
			'Antuco',
			'Cabrero',
			'Laja',
			'Mulchén',
			'Nacimiento',
			'Negrete',
			'Quilaco',
			'Quilleco',
			'San Rosendo',
			'Santa Bárbara',
			'Tucapel',
			'Yumbel',
			'Alto Biobío',
			'Chillán',
			'Bulnes',
			'Cobquecura',
			'Coelemu',
			'Coihueco',
			'Chillán Viejo',
			'El Carmen',
			'Ninhue',
			'Ñiquén',
			'Pemuco',
			'Pinto',
			'Portezuelo',
			'Quillón',
			'Quirihue',
			'Ránquil',
			'San Carlos',
			'San Fabián',
			'San Ignacio',
			'San Nicolás',
			'Treguaco',
			'Yungay',
		]),
	],
	[
		'IX',
		createItemComuna([
			'Temuco',
			'Carahue',
			'Cunco',
			'Curarrehue',
			'Freire',
			'Galvarino',
			'Gorbea',
			'Lautaro',
			'Loncoche',
			'Melipeuco',
			'Nueva Imperial',
			'Padre las Casas',
			'Perquenco',
			'Pitrufquén',
			'Pucón',
			'Saavedra',
			'Teodoro Schmidt',
			'Toltén',
			'Vilcún',
			'Villarrica',
			'Cholchol',
			'Angol',
			'Collipulli',
			'Curacautín',
			'Ercilla',
			'Lonquimay',
			'Los Sauces',
			'Lumaco',
			'Purén',
			'Renaico',
			'Traiguén',
			'Victoria',
		]),
	],
	[
		'XIV',
		createItemComuna([
			'Valdivia',
			'Corral',
			'Lanco',
			'Los Lagos',
			'Máfil',
			'Mariquina',
			'Paillaco',
			'Panguipulli',
			'La Unión',
			'Futrono',
			'Lago Ranco',
			'Río Bueno',
		]),
	],
	[
		'X',
		createItemComuna([
			'Puerto Montt',
			'Calbuco',
			'Cochamó',
			'Fresia',
			'Frutillar',
			'Los Muermos',
			'Llanquihue',
			'Maullín',
			'Puerto Varas',
			'Castro',
			'Ancud',
			'Chonchi',
			'Curaco de Vélez',
			'Dalcahue',
			'Puqueldón',
			'Queilén',
			'Quellón',
			'Quemchi',
			'Quinchao',
			'Osorno',
			'Puerto Octay',
			'Purranque',
			'Puyehue',
			'Río Negro',
			'San Juan de la Costa',
			'San Pablo',
			'Chaitén',
			'Futaleufú',
			'Hualaihué',
			'Palena',
		]),
	],
	[
		'XI',
		createItemComuna([
			'Coihaique',
			'Lago Verde',
			'Aisén',
			'Cisnes',
			'Guaitecas',
			'Cochrane',
			'O’Higgins',
			'Tortel',
			'Chile Chico',
			'Río Ibáñez',
		]),
	],
	[
		'XII',
		createItemComuna([
			'Punta Arenas',
			'Laguna Blanca',
			'Río Verde',
			'San Gregorio',
			'Cabo de Hornos (Ex Navarino)',
			'Antártica',
			'Porvenir',
			'Primavera',
			'Timaukel',
			'Natales',
			'Torres del Paine',
		]),
	],
	[
		'XIII',
		createItemComuna([
			'Cerrillos',
			'Cerro Navia',
			'Conchalí',
			'El Bosque',
			'Estación Central',
			'Huechuraba',
			'Independencia',
			'La Cisterna',
			'La Florida',
			'La Granja',
			'La Pintana',
			'La Reina',
			'Las Condes',
			'Lo Barnechea',
			'Lo Espejo',
			'Lo Prado',
			'Macul',
			'Maipú',
			'Ñuñoa',
			'Pedro Aguirre Cerda',
			'Peñalolén',
			'Providencia',
			'Pudahuel',
			'Quilicura',
			'Quinta Normal',
			'Recoleta',
			'Renca',
			'Santiago',
			'San Joaquín',
			'San Miguel',
			'San Ramón',
			'Vitacura',
			'Puente Alto',
			'Pirque',
			'San José de Maipo',
			'Colina',
			'Lampa',
			'Til-Til',
			'San Bernardo',
			'Buin',
			'Calera de Tango',
			'Paine',
			'Melipilla',
			'Alhué',
			'Curacaví',
			'María Pinto',
			'San Pedro',
			'Talagante',
			'El Monte',
			'Isla de Maipo',
			'Padre Hurtado',
			'Peñaflor',
		]),
	],
]);
